import React from 'react';

export const NoAccess = () => {
  return <h3 style={{ textAlign: 'center', marginTop: '5rem', color: 'maroon' }}>You don't have access to this page</h3>;
};
